import { PAYMENT_SYSTEM_TYPES, PRODUCT_TYPES } from '../../../app/core/constants'

import { template } from 'lodash-es'

/**
 * Header template
 *
 * @type {string}
 */
const headerTemplate = `
  <table>
    <tr>
      <td></td>
      <td align="right">
        <% if (data.purchaseNumber) { %><b>Payment Number: <%=data.purchaseNumber%></b><br><% } %>
        <% if (data.gravyPayment) { %><b>Gr4avy Id: <%=data.transactionId%></b><br><% } %>
        <% if (data.gravyPayment) { %><b>Connector's Id: <%=data.connectorId%></b><br><% } %>
        <% if (!data.gravyPayment && data.transactionId) { %><b><%=data.transactioLabel%>: <%=data.transactionId%></b><br><% } %>
        <% if (data.creditCardNumber) { %><b>Credit Card: XXXX<%=data.creditCardNumber%></b><br><% } %>
        <% if (data.checkNumber) { %><b>Check No: <%=data.checkNumber%></b><br><% } %>
        <% if (data.processDate) { %><b>Process Date: <%=moment.utc(data.processDate).add(data.timezoneOffset, 'hours').format('DD.MM.YYYY')%></b><br><% } %>
      </td>
    </tr>
    <tr>
      <td align="right" colspan="2"><%=data.subscriberInfo.email%></td>
    </tr>
  </table>`

/**
 * Customer template
 *
 * @type {string}
 */
const customerTemplate = `
  <table>
    <tr class="heading">
      <td colspan="5">Customer Information</td>
    </tr>

    <tr class="item">
      <th>Username</th>
      <th>First Name</th>
      <th>Last Name</th>
      <th>Email</th>
      <th>Account Number</th>
    </tr>
    <tr class="item">
      <td style="text-overflow: ellipsis; overflow: hidden; max-width: 150px;"><%=data.subscriberInfo.name%></td>
      <td><%=data.subscriberInfo.firstName%></td>
      <td><%=data.subscriberInfo.lastName%></td>
      <td><%=data.subscriberInfo.email%></td>
      <td><%=data.subscriberInfo.accountNumber%></td>
    </tr>
  </table>`

/**
 * Subscription template
 *
 * @type {string}
 */
const purchaseInformationTemplate = `
  <table>
      <tr class="heading">
          <td colspan="5">Purchase Information</td>
      </tr>
      <% if (data.purchaseReceiptInfo && data.purchaseReceiptInfo.purchaseInfoItems) { %>
          <tr class="item">
              <th>Product Type</th>
              <th>Name</th>
              <th>Active From</th>
              <th>Active Until</th>
              <th>Price</th>
          </tr>
          <% for (let i = 0; i < data.purchaseReceiptInfo.purchaseInfoItems.length; i++) { %>
              <% if (!['Custom Subscription', 'Subscription'].includes(data.purchaseReceiptInfo.purchaseInfoItems[i].productType)) { %>
                  <tr class="item">
                      <td><%=data.purchaseReceiptInfo.purchaseInfoItems[i].productType%></td>
                      <td><%=data.purchaseReceiptInfo.purchaseInfoItems[i].name%></td>
                      <% if (data.purchaseReceiptInfo.purchaseInfoItems[i].activeFrom) { %> <td><%=moment.utc(data.purchaseReceiptInfo.purchaseInfoItems[i].activeFrom).add(data.timezoneOffset, 'hours').format('DD.MM.YYYY HH:mm')%></td><% } %>
                      <% if (!data.purchaseReceiptInfo.purchaseInfoItems[i].activeFrom) { %><td> -- </td> <% } %>
                      <% if (data.purchaseReceiptInfo.purchaseInfoItems[i].activeUntil && !data.purchaseReceiptInfo.purchaseInfoItems[i].unlimited) { %> <td><%=moment.utc(data.purchaseReceiptInfo.purchaseInfoItems[i].activeUntil).add(data.timezoneOffset, 'hours').format('DD.MM.YYYY HH:mm')%> </td> <% } %>
                      <% if (data.purchaseReceiptInfo.purchaseInfoItems[i].activeUntil && data.purchaseReceiptInfo.purchaseInfoItems[i].unlimited) { %> <td> Unlimited </td> <% } %>
                      <% if (!data.purchaseReceiptInfo.purchaseInfoItems[i].activeUntil) { %><td> -- </td> <% } %>
                      <td><%=data.purchaseReceiptInfo.purchaseInfoItems[i].price%><%=data.purchaseReceiptInfo.purchaseInfoItems[i].symbol%></td>
                  </tr>
              <% } %>
              <% if (['Custom Subscription', 'Subscription', 'Add_Device'].includes(data.purchaseReceiptInfo.purchaseInfoItems[i].productType)) { %>
                  <tr class="item">
                      <td style="background-color: #c3f6c3;"><%=data.purchaseReceiptInfo.purchaseInfoItems[i].productType%></td>
                      <td style="background-color: #c3f6c3;"><%=data.purchaseReceiptInfo.purchaseInfoItems[i].name%></td>
                      <% if (data.purchaseReceiptInfo.purchaseInfoItems[i].activeFrom) { %><td style="background-color: #c3f6c3;"><%=moment.utc(data.purchaseReceiptInfo.purchaseInfoItems[i].activeFrom).add(data.timezoneOffset, 'hours').format('DD.MM.YYYY HH:mm')%></td><% } %>
                      <% if (!data.purchaseReceiptInfo.purchaseInfoItems[i].activeFrom) { %><td style="background-color: #c3f6c3;"> -- </td> <% } %>
                      <% if (!data.purchaseReceiptInfo.purchaseInfoItems[i].unlimited) { %> <td style="background-color: #c3f6c3;"><%=moment.utc(data.purchaseReceiptInfo.purchaseInfoItems[i].activeUntil).add(data.timezoneOffset, 'hours').format('DD.MM.YYYY HH:mm')%> </td> <% } %>
                      <% if (data.purchaseReceiptInfo.purchaseInfoItems[i].unlimited) { %><td style="background-color: #c3f6c3;"> Unlimited </td> <% } %>
                      <td style="background-color: #c3f6c3;"><%=data.purchaseReceiptInfo.purchaseInfoItems[i].price%><%=data.purchaseReceiptInfo.purchaseInfoItems[i].symbol%></td>
                  </tr>
              <% } %>
          <% } %>
          <% if (data.transactionFeeEnabled) { %>
            <tr class="item">
              <td colspan="2"></td>
              <td colspan="3" align="right">Transaction Fee: <%=data.purchaseReceiptInfo.transactionFeeAmount%><%=data.purchaseReceiptInfo.symbol%> included </td>
            </tr>
          <% } %>
          <tr class="item">
            <td colspan="2"></td>
            <td colspan="3" align="right">Total: <%=data.purchaseReceiptInfo.totalPrice%><%=data.purchaseReceiptInfo.symbol%> </td>
          </tr>
      <% } %>
  </table>`

/**
 * Payment information template
 *
 * @type {string}
 */
const paymentInformationTemplate = `
  <table>
      <tr class="heading">
          <td colspan="5">Payment Information</td>
      </tr>
      <% if (data.purchaseReceiptInfo && data.purchaseReceiptInfo.purchaseInfoItems) { %>
          <tr>
              <th>Payment Service</th>
              <th>Product Type</th>
              <th>Name</th>
              <th>Auto Pay</th>
              <th>Paid Devices</th>
          </tr>
          <% for (let i = 0; i < data.purchaseReceiptPaymentInfos.length; i++) { %>
              <tr>
                  <td><%=data.purchaseReceiptPaymentInfos[i].paymentSystemType%></td>
                  <td><%=data.purchaseReceiptPaymentInfos[i].productType%></td>
                  <td><%=data.purchaseReceiptPaymentInfos[i].name%></td>
                  <td><%=data.purchaseReceiptPaymentInfos[i].autoPay%></td>
                  <td><%=data.purchaseReceiptPaymentInfos[i].paidDevice%></td>
              </tr>
          <% } %>
      <% } %>
  </table>`

/**
 * Template for print page
 *
 * @type {string}
 */

export const paymentTemplate = `
  ${headerTemplate}

  ${customerTemplate}

  ${purchaseInformationTemplate}

  ${paymentInformationTemplate}
 `

/**
 * Customer template
 *
 * @type {string}
 */
const pageTemplate = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Payment info</title>
  <meta name=viewport content="width=device-width, initial-scale=1">

  <style>
    .invoice-box{
      max-width:800px;
      margin:auto;
      padding:30px;
      border:1px solid #eee;
      box-shadow:0 0 10px rgba(0, 0, 0, .15);
      font-size:14px;
      line-height:24px;
      font-family:'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
      color:#555;
    }

    .invoice-box table{
      width:100%;
      margin:0 0 10px 0;
      line-height:inherit;
      text-align:left;
    }
    .invoice-box table tr.heading td, .invoice-box table tr.heading th{
      border-bottom: 2px solid #ddd;
      font-weight: bold;
      font-size: 18px;
      padding: 10px;
    }
    .invoice-box table td, .invoice-box table th{
      border-bottom:1px solid #ddd;
      padding:5px 10px;
      vertical-align:top;
    }
    .invoice-box table th{
      background:#F5F5F5;
    }

    table.infoBox{
      max-width: 60%;
      margin: 0 auto;
      background: #f7f7f7;
      border-radius: 15px;
      border: 1px dashed #a5a5a5;
      padding: 10px;
      text-align: center;
    }
    table.infoBox tr:last-child td{
      border:none;
    }
    .error {
      color: #FF0000;
    }
  </style>
</head>
<body>
  <div id="print-area" class="invoice-box"></div>
</body>
</html>
`

/**
 * Function generates url for request to data
 *
 * @param {Object} params
 * @return {String}
 */
export function getUrl (params) {
  return `/nora/api/subscribers/${params.subscriber}/purchases/${params.payment}/receipt`
}

/**
 * Prepare data for template
 *
 * @param {Object} data - from response
 * @returns {Object}
 */
export function prepareData (data) {
  const productTypes = angular.copy(PRODUCT_TYPES)
  productTypes.Free_Subscription = 'Subscription'
  data.timezoneOffset = parseInt(window.localStorage.getItem('timezoneOffset'))
  const currencies = JSON.parse(window.localStorage.getItem('currencies') || '[]')
  data.gravyPayment = data.paymentSystemType === 'GR4VY_GATEWAY'
  switch (data.externalPaymentSystemType) {
    case 'PAYPAL_EXPRESS':
      data.transactioLabel = 'Sale ID'
      break
    case 'WESTERN_UNION':
    case 'MONEY_GRAM':
      data.transactioLabel = 'Check ID'
      break
    default:
      data.transactioLabel = 'Transaction ID'
  }
  if (data.purchaseReceiptInfo) {
    data.purchaseReceiptInfo.symbol = currencies.find(c => c.name === data.purchaseReceiptInfo.currencyCode)?.symbol || ` ${data.purchaseReceiptInfo.currencyCode} `
    const subscriptionsArr = []
    const contentAddonsArr = []
    const addonsArr = []
    const contentItemsArr = []
    const accessoryArr = []
    data.purchaseReceiptInfo.purchaseInfoItems.forEach(item => {
      if (['Subscription', 'Custom_Subscription', 'Trial_Subscription', 'Add_Device', 'Free_Subscription'].includes(item.productType)) {
        subscriptionsArr.push(item)
      } else if (item.productType === 'Content_addOn') {
        contentAddonsArr.push(item)
      } else if (item.productType === 'Content_Item') {
        contentItemsArr.push(item)
      } else if (item.productType === 'Accessory') {
        item.activeFrom = null
        item.activeUntil = null
        accessoryArr.push(item)
      } else {
        item.activeFrom = null
        item.activeUntil = null
        addonsArr.push(item)
      }
    })
    data.purchaseReceiptInfo.purchaseInfoItems = subscriptionsArr.concat(accessoryArr, contentAddonsArr, contentItemsArr, addonsArr)
    data.purchaseReceiptInfo.purchaseInfoItems.forEach(item => {
      item.symbol = currencies.find(c => c.name === item.currencyCode)?.symbol || ` ${item.currencyCode} `
      item.productType = productTypes[item.productType]
    })
  }
  const subscriptionsArr = []
  const contentAddonsArr = []
  const addonsArr = []
  const contentItemsArr = []
  const accessoryArr = []
  data.purchaseReceiptPaymentInfos.forEach(item => {
    if (['Subscription', 'Custom_Subscription', 'Trial_Subscription', 'Free_Subscription'].includes(item.productType)) {
      subscriptionsArr.push(item)
    } else if (item.productType === 'Content_addOn') {
      contentAddonsArr.push(item)
    } else if (item.productType === 'Content_Item') {
      contentItemsArr.push(item)
    } else if (item.productType === 'Accessory') {
      accessoryArr.push(item)
    } else {
      addonsArr.push(item)
    }
    item.productType = productTypes[item.productType]
    item.paymentSystemType = PAYMENT_SYSTEM_TYPES[item.paymentSystemType] || '--'
    item.autoPay = item.autoPay ? 'Yes' : 'No'
  })

  data.purchaseReceiptPaymentInfos = subscriptionsArr.concat(accessoryArr, contentAddonsArr, contentItemsArr, addonsArr)
  const popupWin = window.open('')
  popupWin.document.open()
  popupWin.document.write(pageTemplate)
  const tmpl = template(paymentTemplate)
  popupWin.document.getElementById('print-area').innerHTML = tmpl({
    data
  })
  popupWin.document.close()
  popupWin.focus()

  setTimeout(() => { popupWin.print(); popupWin.close() }, 100)
}
